var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.parameter_value),function(elVal,pvIndex){return _c('div',{key:pvIndex},[(elVal === null)?_c('span',[_vm._v("No input provided")]):(['hda', 'hdca', 'dce'].includes(elVal.src))?_c('GenericHistoryItem',{attrs:{"item-id":elVal.id,"item-src":elVal.src}}):_c('span',[_vm._v(" "+_vm._s(elVal.hid)+": "+_vm._s(elVal.name)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }